<script lang="ts">
  import { appStore } from "$lib/stores/app-store.svelte"
  import LoaderCircleIcon from "@lucide/svelte/icons/loader-circle"
</script>
<main class="relative h-full w-full flex items-center justify-center">
  <section class="relative w-max">
    <div class="relative w-28 text-center">
      <img src={undefined}
           class="hidden absolute size-28 -top-32"
           alt="">
      <LoaderCircleIcon class="size-8 inline-block animate-spin text-primary"/>
    </div>
  </section>
</main>